"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const shallow_1 = require("zustand/shallow");
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const DropdownType_1 = __importDefault(require("src/components/dropdown/DropdownType"));
const AdjustCategory = ({ objective, isAllowToUpdate }) => {
    var _a;
    const { objectiveCategories, handleChangeCategory } = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => ({
        objectiveCategories: state.objectiveCategories,
        handleChangeCategory: state.handleChangeCategory
    }), shallow_1.shallow);
    const onChangeCategory = (objectiveCategory) => {
        handleChangeCategory(objective === null || objective === void 0 ? void 0 : objective.id, objectiveCategory);
    };
    return (react_1.default.createElement("div", { className: "dropdown-container flex items-center", "data-cy": "weight-type" },
        react_1.default.createElement(DropdownType_1.default, { defaultValue: (_a = objective === null || objective === void 0 ? void 0 : objective.objectiveCategory) === null || _a === void 0 ? void 0 : _a.id, handleChange: onChangeCategory, objectiveCategories: objectiveCategories, dropdownPosition: "left", disabled: !isAllowToUpdate, dropdownTriggerClass: "w-full" })));
};
exports.default = AdjustCategory;
